import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@vaki/vakers/shell/feature').then((feat) => feat.vakersMainRoutes)
  }
];
